import React from "react";
import { Reveal } from "./Reveal";

export const PageHero = ({ overline, title, subtitle, testid }) => {
  return (
    <section data-testid={testid} className="relative pt-40 pb-16 border-b border-white/10 grid-lines">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-teal mb-6">{overline}</p>
        </Reveal>
        <Reveal delay={0.08}>
          <h1 className="font-display text-5xl sm:text-6xl md:text-7xl font-black uppercase tracking-tighter leading-[0.9] max-w-4xl">
            {title}
          </h1>
        </Reveal>
        {subtitle && (
          <Reveal delay={0.16}>
            <p className="mt-6 text-lg text-slate-400 max-w-2xl leading-relaxed">{subtitle}</p>
          </Reveal>
        )}
      </div>
    </section>
  );
};
